import { API_ROUTES } from '@/api/apiRoutes';
import { safeAxios } from '@/services/safeAxios';

export const updateAutoApproveVerifiedModels = (workspaceId: string, shouldAutoApproveVerifiedModels: boolean) =>
  safeAxios.put(API_ROUTES.workspaces.byId({ workspaceId }), { shouldAutoApproveVerifiedModels });

export const updateModelApprovalSetting = (workspaceId: string, isModelApprovalSettingEnabled: boolean) =>
  safeAxios.put(API_ROUTES.workspaces.byId({ workspaceId }), { isModelApprovalSettingEnabled });

export const updateVerifiedModelNotifications = (workspaceId: string, shouldNotifyVerifiedModels: boolean) =>
  safeAxios.put(API_ROUTES.workspaces.byId({ workspaceId }), { shouldNotifyVerifiedModels });
